export default {"src":"/_next/static/media/phone.daaec04d.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};